// Modo "pantallas": build para las pantallas físicas de las sedes (kioscos).
// Valor fijo por rama: `true` en screens-dev, `false` en dev/main. Al mergear, conservar el de la rama destino.
export const IS_SCREENS_MODE: boolean = false;

// Clase que se agrega al <body> en modo pantallas, para los ajustes que son solo de estilo.
export const SCREENS_MODE_CLASS = "screens-mode";
